export function buildUrl(category: string, answer: string) {
  return `/${category}/${answer}`;
}
